class Carousel {
  constructor(container, slides, params) {
    this.container = container;
    this.carousel = container.querySelector('.js-carousel') || this.container;
    this.slider = container.querySelector('.js-carousel-items');
    this.dots = this.container.querySelector('.js-carousel-dots ul');
    this.legend = document.querySelector('.js-carousel-title');
    this.slides = slides;
    this.length = slides ? slides.length : 0;
    this.profileInfos = this.container.nextElementSibling;
    this.posX = 0;
    this.touching = false;
    this.animating = false;

    let defaultParams = {
      type: 'fade',
      hasTimeout: false,
      transition: 1000,
      cssTransition: 1000,
      responsive: false,
      responsiveBreakpoint: 769,
      responsiveVisibleSlides: 1,
      auto: false,
      delay: 4000,
      infinite: false,
      autoHeigth: false,
    }

    this.params = Object.assign(defaultParams, params);
    this.init();
  }


  ////////////
  // INIT ////
  ////////////

  init() {
    // if (this.params.type == 'fade') {
      this.currentIndex =  0;
    // } else {
    //   this.middleIndex = this.isResponsive() ? 0 : (this.params.visibleSlides - 1)/2;
    //   this.currentIndex = this.middleIndex;
    // }

    if (this.length) {
      this.clear();
      this.setControls(this.length > 1);

      this.slides.map((data, index) => {
        this.slider.innerHTML += this.setSlide(data.path, index);

        if (this.dots) {
          this.dots.innerHTML += this.setDot(index);
        }
      })
    } else {
      this.slides = [...this.slider.querySelectorAll('.js-carousel-item')];
      // this.query = this.slider.querySelectorAll('.js-carousel-item');
      // this.element = this.slider.getElementsByClassName('js-carousel-item');
      this.length = this.slides.length;
      // this.clear();

      // console.log(this.query);
      // console.log(this.element);
      // console.log(this.slides);

      if (this.params.infinite) {
        // Create Clones
        let first = this.slides[this.length - 1].cloneNode(true);
        let last = this.slides[0].cloneNode(true);

        first.dataset.index = -1;
        last.dataset.index = this.length;

        this.slides.forEach((slide, index) => {
          slide.dataset.index = index;

          this.slider.appendChild(slide);
        })

        // Insert Clones
        this.slider.insertBefore(first, this.slider.firstChild);
        this.slider.appendChild(last);
      } else {
        this.slides.forEach((slide, index) => {
          slide.dataset.index = index;

          this.slider.appendChild(slide);
        })
      }

      if (this.dots) {
        let dots = [...this.dots.querySelectorAll('.js-carousel-dot')];

        // this.clear(this.dots);
        dots.forEach((dot, index) => {
          dot.dataset.index = index;

          this.dots.appendChild(dot);
        })
      }

      this.setControls(this.length > 1);
    }

    this.currentIndex = this.getHashIndex();

    this.setNeighboursClasses();
    this.initSlider();
    this.bindVisibilityChange();
    this.loop();
  }

  getHashIndex() {
    let index = 0;
    if (window.location.hash) {
      let hash = window.location.hash.replace('#', '');
      let current = this.slides.filter((slide) => slide.dataset.hash == hash);
      if (current.length) {
        index = current[0].dataset.index;
      }
    }
    return index;
  }

  bindVisibilityChange() {
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState == 'hidden') {
        clearInterval(this.interval)
      } else {
        this.loop();
      }
    });
  }

  initSlider() {
    if (this.params.type != 'fade') {
      this.setElementsWidth();
      this.initHammer();

      if (this.params.infinite) {
        this.next(true, false, false);
      } else if (this.currentIndex != 0) {
        this.goTo(this.currentIndex, true, false);
      }

      window.addEventListener('resize', (event) => {
        this.setElementsWidth();
        this.translate();
      })

      window.addEventListener('hashchange', (event) => {
        let title = window.location.hash.replace('#', '');
        let index = this.container.querySelector('[data-hash="'+title+'"]').dataset.index;

        if (!this.animating) {
          this.goTo(index);
        }
      })
    }
  }

  ///////////////
  // ACTIONS ////
  ///////////////

  prev(translate = true, transition = true) {
    let index = this.currentIndex - 1;
    this.goTo(index, translate, transition);
  }

  next(translate = true, transition = true, increment = true) {
    let index = increment ? this.currentIndex + 1 : this.currentIndex;
    this.goTo(index, translate, transition);
  }

  goTo(index, translate = true, transition = true) {
    this.setTransition();

    if (this.params.infinite) {
      if (index >= -1 && index <= this.length) {
        this.currentIndex = index;
      } else if (Math.sign(index) == -1) {
        this.currentIndex = this.length - 1;
      } else if (index > this.length) {
        this.currentIndex = 0;
      }
    } else {
      if (index >= 0) {
        this.currentIndex = index % this.length;
      } else {
        this.currentIndex = this.length - 1;
      }
    }

    this.setNeighboursClasses();

    if (this.dots) {
      let activeDot = this.container.querySelector('.carousel-dot.is-active');
      let current;

      if (index < 0) {
        current = this.container.querySelector('.carousel-dot[data-index="'+ parseInt(this.length - 1) +'"]')
      } else if (index == this.length) {
        current = this.container.querySelector('.carousel-dot[data-index="0"]')
      } else {
        current = this.container.querySelector('.carousel-dot[data-index="'+ this.currentIndex +'"]')
      }
    }

    if (this.params.type == 'slide' && translate) {
      this.translate(transition);
    }
  }


  //////////////
  // SETTERS ///
  //////////////

  setSlide(path, index) {
    return index == this.currentIndex ? `<div class="carousel-item is-active" data-index="${index}"><img src="${path}"></div>` : `<div class="carousel-item" data-index="${index}"><img src="${path}"></div>`;
  }

  setDot(index) {
    return index == this.currentIndex ? `<li class="carousel-dot is-active" data-index="${index}">` : `<li class="carousel-dot" data-index="${index}"></li>`;
  }

  setActiveClasses() {
    let actives = [...this.container.querySelectorAll('.is-active')];
    let currents = [...this.container.querySelectorAll('[data-index="'+ this.currentIndex +'"]')];

    actives.forEach((current) => {
      current.classList.remove('is-active');
    })

    currents.forEach((current) => {
      current.classList.add('is-active');
      current.classList.remove('is-prev');
      current.classList.remove('is-next');
    })

    if (this.current.dataset.title && this.legend) {
      this.legend.innerHTML = this.current.dataset.title;
    }

    if (this.current.dataset.hash) {
      window.location.hash = this.current.dataset.hash;
    }

    if (this.params.autoHeigth && window.innerWidth < this.params.responsiveBreakpoint) {
      setTimeout(() => {
        let current = this.slider.querySelector('[data-index="'+ this.currentIndex +'"]')
        let height = current.offsetHeight;
        console.log(height)
        this.slider.style.height = this.toPx(height);
      }, 500)
    }
  }

  setNeighboursClasses() {
    this.current = this.container.querySelector('.js-carousel-item[data-index="'+ this.currentIndex +'"]')

    let prev = this.current.previousElementSibling;
    let next = this.current.nextElementSibling;

    while (prev) {
      prev.classList.add('is-prev');
      prev.classList.remove('is-next');
      prev = prev.previousElementSibling;
    }

    while (next) {
      next.classList.add('is-next');
      next.classList.remove('is-prev');
      next = next.nextElementSibling;
    }

    if (this.params.infinite && this.currentIndex >= this.length - 1) {
      let first = this.container.querySelector('.js-carousel-item[data-index="0"]');
      first.classList.remove('is-prev');
      first.classList.remove('is-next');
    }

    if (this.params.infinite && this.currentIndex < 0) {
      let last = this.container.querySelector('.js-carousel-item[data-index="'+parseInt(this.length - 1)+'"]');
      last.classList.remove('is-prev');
      last.classList.remove('is-next');
    }

    this.setActiveClasses()
  }

  setControls(hasLength) {
    if (hasLength) {
      // REDEFINE SLIDER REFERENCE
      this.slider = this.container.querySelector('.js-carousel-items');
      this.dots = this.container.querySelector('.carousel-dots ul');

      this.container.addEventListener('click', (event) => {
        if (!this.animating) {
          if (event.srcElement.classList.contains('js-carousel-control')) {
            event.srcElement.classList.contains('prev') ? this.prev() : this.next();
            this.loop();
          }

          if (event.srcElement.classList.contains('carousel-item')) {
            let index = event.srcElement.dataset.index;
            index != this.currentIndex ? this.goTo(index) : () => {};
            this.loop();
          }

          if (event.srcElement.classList.contains('carousel-dot')) {
            let index = parseInt(event.srcElement.dataset.index);
            index != this.currentIndex ? this.goTo(index) : () => {};
            this.loop();
          }
        }
      })
    }
  }

  setElementsWidth() {
    if (this.isResponsive()) {
      this.visibleSlides = this.params.responsiveVisibleSlides;
    } else {
      this.visibleSlides = this.params.visibleSlides;
    }

    this.middleIndex = this.isResponsive() ? 0 : (this.visibleSlides - 1) / 2;

    let containerWidth = this.carousel.offsetWidth;
    this.itemWidth = this.carousel.offsetWidth / this.visibleSlides;
    let sliderWidth = this.params.infinite ? this.itemWidth * (this.length + 2) : this.itemWidth * this.length;

    this.setTransition(0);

    this.slider.style.width = this.toPx(sliderWidth);

    let slides = [...this.slider.querySelectorAll('.carousel-item')];

    slides.forEach((el, index) => {
      el.style.width = this.toPx(this.itemWidth);
    })

    this.carousel.classList.add('is-init');
  }


  //////////////
  // HAMMER ////
  //////////////

  initHammer() {
    if (window.innerWidth < this.params.responsiveBreakpoint) {
      this.hammer = new Hammer(this.carousel, {
        touchAction: "pan-y"
      });

      this.hammer.on("panleft panright", (event) => {
        if (Math.abs(event.deltaX) > Math.abs(event.deltaY) || this.touching) {
        //   console.log('starting')
          clearInterval(this.interval);
          this.setTransition(0);
          this.slider.style.transform = 'translateX('+ this.toPx(this.posX + event.deltaX) +')';
          this.touching = true;
        }
      });

      this.hammer.on("panend", (event) => {
        // console.log(event)
        let current = -(Math.round(event.deltaX / (this.itemWidth / 2))) + this.currentIndex;
        this.setTransition();
        current >= 0 ? this.goTo(current) : this.goTo(this.length - 1);

        this.touching = false;
        this.loop();
      });
    }

    // this.hammer.on("swipe", (event) => {
    //   clearInterval(this.interval);
    //   console.log(Math.sign(event.deltaX))
    //   let current = -Math.sign(event.deltaX) + this.currentIndex;

    //   this.slider.style.transitionDuration = this.params.transition;
    //   current >= 0 ? this.goTo(current) : this.goTo(this.length - 1);

    //   this.loop();
    // });
  }

  ///////////////////////////////
  // TRANSFORM AND TRANSITION ///
  ///////////////////////////////

  setTransition(value = this.params.transition) {
    value = value != 0 ? value/1000 + 's' : '0s';
    this.slider.style.transitionDuration = value;
  }

  translate(transition = true) {
    if (!transition) {
      this.setTransition(0);
    } else {
      this.animating = true;
    }

    this.posX = this.params.infinite ? -this.itemWidth * (this.currentIndex + 1) : -this.itemWidth * this.currentIndex;
    this.slider.style.transform = 'translateX('+ this.toPx(this.posX) +')';
    this.slider.style['msTransform'] = 'translateX('+ this.toPx(this.posX) +')';
    this.slider.style['webkitTransform'] = 'translateX('+ this.toPx(this.posX) +')';

    setTimeout(() => {
      this.animating = false;
      if (this.currentIndex < 0) {
        this.prev(true, false)
      } else if (this.currentIndex == this.length) {
        this.next(true, false)
      }
    }, this.params.cssTransition)
  }

  //////////////
  // UTILS /////
  //////////////

  toPx(value) {
    return value + "px";
  }

  isResponsive() {
    return this.params.responsive && window.innerWidth < this.params.responsiveBreakpoint;
  }

  clear(container = this.slider, el = '') {
    container.innerHTML = el;
  }

  loop() {
    if (this.params.auto) {
      this.interval;

      clearInterval(this.interval);

      this.interval = setInterval(() => {
        this.next();
      }, this.params.delay);
    }
  }
}

if (document.getElementsByClassName('js-carousel-slider')) {
  let carousels = [...document.getElementsByClassName('js-carousel-slider')];

  carousels.forEach((c) => {
    new Carousel(c, null, {
      type: 'slide',
      visibleSlides: 1,
      auto: true,
      transition: 1500,
      cssTransition: 1700,
      delay: 5000,
      infinite: true,
    });
  })
}

if (document.getElementsByClassName('js-carousel-container')) {
  let carousels = [...document.getElementsByClassName('js-carousel-container')];

  carousels.forEach((c) => {
    new Carousel(c, null, {
      type: 'slide',
      visibleSlides: 1,
      transition: 1500,
      cssTransition: 0,
      delay: 5000,
      autoHeigth: true,
    });
  })
}
